import { render, staticRenderFns } from "./RecipeSwiper.vue?vue&type=template&id=71d4904b&"
import script from "./RecipeSwiper.vue?vue&type=script&lang=js&"
export * from "./RecipeSwiper.vue?vue&type=script&lang=js&"
import style0 from "./RecipeSwiper.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RecipeSwiper.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports